module.exports = __webpack_public_path__ + "static/media/maite_harinadetrigo.565cefff.png";